// extracted by mini-css-extract-plugin
module.exports = {"styledTooltip":"yX5wKlzF","unit":"sXLnrW0e"};